// extracted by mini-css-extract-plugin
export default {"definitionList":"ResultsCard_definitionList__yaLgw"};